<template lang="pug">
b-form-select(
  :value="value"
  :size="size"
  :class="{ 'is-invalid': dirty == true && error == true, 'is-valid': dirty == true && error == false }"
  @input="handleInput"
  )
  option(
    value="" disabled selected
    )
    | {{ $t("message.select_option") }}
  option(
    v-for="option in options"
    :value="getDDLValue(option)"
    v-if="getDDLValue(option) != excludeOpt && isEnableBankAccType(option.bank_acc_type) && isEnableBankId(option.bank_id) && greaterThanZero(option.account_balance) && isActive(option.status)"
    )
    | {{ option.bank_name }} | {{ option.bank_acc_no }} | {{ option.bank_acc_holder }} | {{ option.account_balance | currency }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import xhr from "@/plugins/xhr.js";

export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "md"
    },
    dirty: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    excludeOpt: {
      type: String,
      default: ""
    },
    filterBankAccType: {
      type: Boolean,
      default: false
    },
    filterBalance: {
      type: Boolean,
      default: false
    },
    filterBankAccStatus: {
      type: Boolean
    },
    hideBankAccType: {
      type: Array,
      default: null
    },
    hideBankId: {
      type: Array,
      default: null
    },
    optionList: {
      type: Array,
      default: null
    }
  },
  data: () => ({
    options: [],
    feedback: {
      success: true,
      status: ""
    }
  }),
  mounted() {
    if (this.optionList == null) {
      this.getBankAccList();
    } else {
      console.log(this.optionList)
      this.options = this.optionList
    }
  },
  methods: {
    getDDLValue(obj) {
      return (
        obj.bank_id.toUpperCase().trim() +
        " - " +
        obj.bank_acc_no.toUpperCase().trim() +
        " - " +
        obj.bank_acc_holder.toUpperCase().trim() +
        " - " +
        obj.account_balance
          .toString()
          .toUpperCase()
          .trim()
      );
    },
    getBankAccList() {
      var args = {
        session_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.username,
        bank_acc_type: "BOTH",
        bank_status: 1
      };
      this.loading = true;
      xhr
        .doRequest(args, xhr.ACCOUNT.bankList)
        .then(res => {
          this.loading = false;
          this.options = res.data.bank_list;
        })
        .catch(res => {
          this.loading = false;
          this.$helpers.handleFeedback(res.status);
        });
    },
    isActive(status) {
      if (this.filterBankAccStatus) {
        if (status == true) return true;
        else return false;
      }
      return true;
    },
    isEnableBankAccType(value) {
      if (this.hideBankAccType && this.hideBankAccType.length > 0) {
        if (this.hideBankAccType.includes(value)) return false;
      }
      return true;
    },
    isEnableBankId(value) {
      if (this.hideBankId && this.hideBankId.length > 0) {
        if (this.hideBankId.includes(value)) return false;
      }
      return true;
    },
    greaterThanZero(balance) {
      if (this.filterBalance) {
        if (balance > 0) return true;
        else return false;
      }
      return true;
    },
    handleInput(e) {
      this.$emit("input", e);
    }
  }
};
</script>
